var _       = require('underscore');
var $       = require('jquery');
var ui_templates = require("ui-templates");
var Core        = ui_templates.Core;
var SidebarPackageGeneratorListItem = require('./sidebar__package__generator__list__item.js');

class SidebarPackageGeneratorList extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
              'theme': 'dark'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar__package__generator__list js-editor__sidebar__package__generator__list"></div>
        `;

        super.render();
    }

    addItem(name, thumbnail){
        return new SidebarPackageGeneratorListItem({
            target: this.$el,
            fields: {
                "name": name,
                "thumbnail": thumbnail,
                "theme": this._options.fields["theme"]
            }
        });
    }
}

module.exports = SidebarPackageGeneratorList;
